module.exports = __webpack_public_path__ + "static/6-0d168fd875beb3a1ea6e5f1169e70a19.jpg";